import { Vector2 } from 'three';

export function getLineSkewAngle(point1: Vector2, point2: Vector2) {
  return point2.clone().sub(point1).angle();
}
